// import moment from 'moment';

import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchReportGroupDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'report_group/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchReportDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'report/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchReportById(app, id) {
  return common.getDoc(app, { id, docType: DocType.REPORT });
}

export function executeReport(app, params) {
  const { reportId, portletType, tableRows, reportFilters } = params || {};
  // const { dateFrom, dateTo } = reportFilters || {};
  const service = app.service('report-svc/run-report');

  const query = {
    reportId,
    portletType,
    tableRows,
    filters: {
      ...reportFilters,
      // Handled prior to reaching this function.
      // dateFrom: dateFrom && moment(dateFrom).utc().format(),
      // dateTo: dateTo && moment(dateTo).utc().format(),
    },
  };

  return service.create(query);
}

export function exportReport( app, params ) {
  const service = app.service('report-svc/export');

  const {
    filters,
    pivotBy,
    report_columns,
    reportId,
    reportType,
  } = params || {};

  const query = {
    filters,
    pivotBy,
    reportId,
    reportType,
    reportColumns: report_columns,
  }

  return service.create(query, null, false, {
    responseType: 'arraybuffer'
  });
}

export function getOmsQuickReport(app, filters) {
  const service = app.service('oms/control_record');
  const res = service.get('quick_report', filters);
  return res;
}
